import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import dayjs from 'hb-react/shared/utils/dayjs/dayjs';

const PublicationDate = ({ publishedAt }) => {
  if (!publishedAt) return null;

  const isUSEnglish =
    window.I18n?.locale === 'en' || window.I18n?.locale === 'en-US';
  const dateFormat = isUSEnglish ? 'MMMM D, YYYY' : 'D MMMM YYYY';

  return (
    <DateStyled>
      {__('Published on %{date}').i__({
        date: dayjs(publishedAt).format(dateFormat),
      })}
    </DateStyled>
  );
};

export default PublicationDate;

const DateStyled = styled(Box).attrs({
  font: 'body-regular-asphalt',
  display: 'block',
})``;
